import React from 'react'
import Link from 'gatsby-link'
import categories from '../../support/categories.js'
import './index.scss'
const _ = require("lodash")

const categoryGroupName = 'Work'
const allCategoryName = 'All'
const categoryNames = categories.hasOwnProperty(categoryGroupName) ? categories[categoryGroupName] : []
const categoryName = 'Industry';

const linkClasses = (categoryName, currentCategory) => {
  let classNames = 'dl-side-menu_item-link'
  if (currentCategory && categoryName === currentCategory) {
    classNames += ' dl-side-menu_item-link--selected'
  }
  return classNames
}

const menuList = (currentCategory) => {
  const allCategoryLink = <Link className={linkClasses(allCategoryName, currentCategory)} to={'/'} key={_.kebabCase(allCategoryName)}>{allCategoryName}</Link>
  const otherCategoryLinks = categoryNames.map((category) => (
      <Link className={linkClasses(category, currentCategory)} to={`/categories/${_.kebabCase(category)}`} key={_.kebabCase(category)}>{category}</Link>
    ))
  return [allCategoryLink, ...otherCategoryLinks]
}

class Layout extends React.Component  {
  constructor(props) {
    super(props)
    this.state = { showMenu: false }
  }

  render() {
    const { category } = this.props;
    return (
        <div
            className="dl-side-menu_menu-cont justify-content-center"
        >
          <div className="dl-side-menu_menu-cat-title">
            {categoryName}
          </div>
          <div className="dl-side-menu_menu-items">
            {menuList(category)}
          </div>
        </div>
  )
  }
}

export default Layout
